<ng-template #table>
  <table [attr.aria-label]="'Standardrechtbelastungen' | translate" class="cap-table-detail-manual">
    <thead>
      <tr>
        <th>{{"RechtsgrundArt" | translate}}</th>
        <th>{{"GrundstückPerson" | translate}}</th>
        <th>{{"Rechtsgrund" | translate}}</th>
      </tr>
    </thead>
    <tbody>
      @for (lastRechtGruppeVm of standardRechtMasterVm.lastRechtGruppenVm; track lastRechtGruppeVm; let odd = $odd) {
        @for (lrgrundstueck of lastRechtGruppeVm.object.grundstueckeLast | orderByGrundstuecknummer; track lrgrundstueck) {
          <tr [ngClass]="{ even: !odd, odd: odd }" class="borderTop">
            <td [capHistinfo]="lrgrundstueck.histInfo">
              {{ lrgrundstueck.belastungArt | belastungArt: language }}
            </td>
            <td>
              <cap-kompakt-grundstueck [capHistinfo]="lrgrundstueck.histInfo" [item]="lrgrundstueck.grundstueck"></cap-kompakt-grundstueck>
              <cap-kompakt-timepoint [item]="lrgrundstueck.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
            <td>
              @for (rechtsgrund of lrgrundstueck.rechtsgruende; track rechtsgrund) {
                <p>
                  <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                </p>
              }
            </td>
          </tr>
        }
        @for (lrgrundstueck of lastRechtGruppeVm.object.grundstueckeRecht | orderByGrundstuecknummer; track lrgrundstueck) {
          <tr [ngClass]="{ even: !odd, odd: odd }" class="noYPadding">
            <td></td>
            <td class="ps-4">
              <span [capHistinfo]="lrgrundstueck.histInfo">{{ "ZuGunsten" | translate }}</span>
              <cap-kompakt-grundstueck [capHistinfo]="lrgrundstueck.histInfo" [item]="lrgrundstueck.grundstueck"></cap-kompakt-grundstueck>
              <cap-kompakt-timepoint [item]="lrgrundstueck.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
            <td>
              @for (rechtsgrund of lrgrundstueck.rechtsgruende; track rechtsgrund) {
                <p>
                  <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                </p>
              }
            </td>
          </tr>
        }
        @for (lrgrundstueck of lastRechtGruppeVm.object.grundstueckeLastRecht | orderByGrundstuecknummer; track lrgrundstueck) {
          <tr [ngClass]="{ even: !odd, odd: odd }" class="noYPadding">
            <td>
              <span>{{ lrgrundstueck.belastungArt | belastungArt: language | translate }}</span>
            </td>
            <td>
              <cap-kompakt-grundstueck [capHistinfo]="lrgrundstueck.histInfo" [item]="lrgrundstueck.grundstueck"></cap-kompakt-grundstueck>
              <cap-kompakt-timepoint [item]="lrgrundstueck.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
            <td>
              @for (rechtsgrund of lrgrundstueck.rechtsgruende; track rechtsgrund) {
                <p>
                  <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                </p>
              }
            </td>
          </tr>
        }
        @for (lastRechtPersonVm of lastRechtGruppeVm.lastRechtPersonenVm; track lastRechtPersonVm) {
          @for (personGbVersionVm of lastRechtPersonVm.personGbMasterVm?.versionenVm; track personGbVersionVm; let last = $last) {
            <tr [ngClass]="{ even: !odd, odd: odd }" class="noYPadding">
              <td></td>
              <td class="ps-4">
                <span [capHistinfo]="personGbVersionVm.object.histInfo">{{ "ZuGunsten" | translate }}</span>
                <cap-kompakt-persongb
                  [auskunftsperre]="getAuskunftsperre(lastRechtPersonVm.personGbMasterVm.object.hasAuskunftssperre)"
                  [capHistinfo]="personGbVersionVm.object.histInfo"
                  [item]="personGbVersionVm.object"
                  [itemMasterId]="lastRechtPersonVm.personGbMasterVm.object.id">
                </cap-kompakt-persongb>
                <cap-kompakt-timepoint [item]="personGbVersionVm.object.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
              </td>
              <td>
                @if (last) {
                  @for (rechtsgrund of lastRechtPersonVm.object.rechtsgruende; track rechtsgrund) {
                    <p>
                      <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                    </p>
                  }
                }
              </td>
            </tr>
          }
        }
      }
    </tbody>
  </table>
</ng-template>

@if (!standardRechtMasterVm || standardRechtMasterVm.lastRechtGruppenVm?.length == 0) {
  <ng-template [ngTemplateOutlet]="keine"></ng-template>
} @else {
  <table [attr.aria-label]="'Standardrechtbelastungen' | translate" class="cap-table-detail-manual">
    <thead>
      <tr>
        <th>{{"RechtsgrundArt" | translate}}</th>
        <th>{{"GrundstückPerson" | translate}}</th>
        <th>{{"Rechtsgrund" | translate}}</th>
      </tr>
    </thead>
    <tbody>
      @for (lastRechtGruppeVm of standardRechtMasterVm.lastRechtGruppenVm; track lastRechtGruppeVm; let odd = $odd) {
        @for (lrgrundstueck of lastRechtGruppeVm.object.grundstueckeLast | orderByGrundstuecknummer; track lrgrundstueck) {
          <tr [ngClass]="{ even: !odd, odd: odd }" class="borderTop">
            <td [capHistinfo]="lrgrundstueck.histInfo">
              {{ lrgrundstueck.belastungArt | belastungArt: language }}
            </td>
            <td>
              <cap-kompakt-grundstueck [capHistinfo]="lrgrundstueck.histInfo" [item]="lrgrundstueck.grundstueck"></cap-kompakt-grundstueck>
              <cap-kompakt-timepoint [item]="lrgrundstueck.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
            <td>
              @for (rechtsgrund of lrgrundstueck.rechtsgruende; track rechtsgrund) {
                <p>
                  <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                </p>
              }
            </td>
          </tr>
        }
        @for (lrgrundstueck of lastRechtGruppeVm.object.grundstueckeRecht | orderByGrundstuecknummer; track lrgrundstueck) {
          <tr [ngClass]="{ even: !odd, odd: odd }" class="noYPadding">
            <td></td>
            <td class="ps-4">
              <span [capHistinfo]="lrgrundstueck.histInfo">{{ "ZuGunsten" | translate }}</span>
              <cap-kompakt-grundstueck [capHistinfo]="lrgrundstueck.histInfo" [item]="lrgrundstueck.grundstueck"></cap-kompakt-grundstueck>
              <cap-kompakt-timepoint [item]="lrgrundstueck.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
            <td>
              @for (rechtsgrund of lrgrundstueck.rechtsgruende; track rechtsgrund) {
                <p>
                  <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                </p>
              }
            </td>
          </tr>
        }
        @for (lrgrundstueck of lastRechtGruppeVm.object.grundstueckeLastRecht | orderByGrundstuecknummer; track lrgrundstueck) {
          <tr [ngClass]="{ even: !odd, odd: odd }" class="noYPadding">
            <td>
              <span>{{ lrgrundstueck.belastungArt | belastungArt: language | translate }}</span>
            </td>
            <td>
              <cap-kompakt-grundstueck [capHistinfo]="lrgrundstueck.histInfo" [item]="lrgrundstueck.grundstueck"></cap-kompakt-grundstueck>
              <cap-kompakt-timepoint [item]="lrgrundstueck.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
            <td>
              @for (rechtsgrund of lrgrundstueck.rechtsgruende; track rechtsgrund) {
                <p>
                  <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                </p>
              }
            </td>
          </tr>
        }
        @for (lastRechtPersonVm of lastRechtGruppeVm.lastRechtPersonenVm; track lastRechtPersonVm) {
          @for (personGbVersionVm of lastRechtPersonVm.personGbMasterVm?.versionenVm; track personGbVersionVm; let last = $last) {
            <tr [ngClass]="{ even: !odd, odd: odd }" class="noYPadding">
              <td></td>
              <td class="ps-4">
                <span [capHistinfo]="personGbVersionVm.object.histInfo">{{ "ZuGunsten" | translate }}</span>
                <cap-kompakt-persongb
                  [auskunftsperre]="getAuskunftsperre(lastRechtPersonVm.personGbMasterVm.object.hasAuskunftssperre)"
                  [capHistinfo]="personGbVersionVm.object.histInfo"
                  [item]="personGbVersionVm.object"
                  [itemMasterId]="lastRechtPersonVm.personGbMasterVm.object.id">
                </cap-kompakt-persongb>
                <cap-kompakt-timepoint [item]="personGbVersionVm.object.histInfo.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
              </td>
              <td>
                @if (last) {
                  @for (rechtsgrund of lastRechtPersonVm.object.rechtsgruende; track rechtsgrund) {
                    <p>
                      <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                    </p>
                  }
                }
              </td>
            </tr>
          }
        }
      }
    </tbody>
  </table>
}
<ng-template #keine>
  <div class="mb-2">
    <span>{{"Keine" | translate}}</span>
  </div>
</ng-template>
